import type { DiagramLabelPosition, DiagramLabelStyles } from './diagram.types';
import { getLabelPosition } from './utils/diagramUtils';
import { classNames } from '../utils/UNSAFE_classNames';
import { labelStyles } from './themes/DiagramStyles.css';
import type { TextDimensions } from '../hooks/PRIVATE_useTextDimensions';
import { Property } from 'csstype';

/**
 * Props for the label component
 */
type LabelProps = {
  styles?: LabelStyles;
  text: string;
  position: DiagramLabelPosition;
  dimensions: TextDimensions;
  isRTL: boolean;
};

/**
 * Label styles
 */
type LabelStyles = DiagramLabelStyles & {
  borderStyle?: Property.BorderStyle;
};

export const DiagramLabel = ({ text, position, styles, dimensions, isRTL }: LabelProps) => {
  const { labelStyle, labelBorderStyle } = labelStyles;

  const labelPosition = getLabelPosition(dimensions, position, isRTL);
  const labelRotation = getLabelRotation(position);
  return (
    <div
      class={classNames([labelStyle, styles && styles.borderColor && labelBorderStyle])}
      style={{
        top: labelPosition.y,
        left: labelPosition.x,
        ...styles,
        ...labelRotation
      }}>
      {text}
    </div>
  );
};

/**
 * Returns the label rotation props
 * @param position
 * @returns rotation props
 */
function getLabelRotation(position: DiagramLabelPosition) {
  const rotationAngle = position.rotationAngle;
  const rotationPoint = position.rotationPoint;
  const rotation: {
    transform?: string;
    'transform-origin'?: string;
  } = {};
  if (rotationAngle) {
    rotation['transform'] = `rotate(${rotationAngle}deg)`;
  }
  if (rotationPoint) {
    rotation['transform-origin'] = `${rotationPoint.x}px ${rotationPoint.y}px`;
  }
  return rotation;
}
